export const menuRoutes = [
  {
    path: '/authorized_list',
    name: 'AuthorizedList',
    component: () => import(/* webpackChunkName: "AuthorizedList" */ '@views/AuthorizedList/AuthorizedList.vue'),
  },
  {
    path: '/coop_apply_list',
    name: 'CoopApplyList',
    component: () => import(/* webpackChunkName: "AuthorizedList" */ '@views/AuthorizedList/CoopApplyList.vue'),
  },
  {
    path: '/interface_list',
    name: 'InterfaceList',
    component: () => import(/* webpackChunkName: "InterfaceList" */ '@views/InterfaceList/InterfaceList.vue'),
  },
  {
    path: '/coop_api_qps_monitor_list',
    name: 'CoopApiQpsMonitorList',
    component: () =>
      import(/* webpackChunkName: "CoopApiQpsMonitorList" */ '@views/MonitorList/CoopApiQpsMonitorList.vue'),
  },
  {
    path: '/coop_qps_monitor_list',
    name: 'CoopQpsMonitorList',
    component: () => import(/* webpackChunkName: "CoopQpsMonitorList" */ '@views/MonitorList/CoopQpsMonitorList.vue'),
  },
  {
    path: '/api_qps_monitor_list',
    name: 'ApiQpsMonitorList',
    component: () => import(/* webpackChunkName: "ApiQpsMonitorList" */ '@views/MonitorList/ApiQpsMonitorList.vue'),
  },
  {
    path: '/role',
    name: 'Role',
    component: () => import(/* webpackChunkName: "Role" */ '@views/role/Role.vue'),
  },
  {
    path: '/account',
    name: 'Account',
    component: () => import(/* webpackChunkName: "Account" */ '@views/account/Account.vue'),
  },
  {
    path: '/api_qps_flow_chart',
    name: 'ApiQpsMonitorList',
    component: () => import(/* webpackChunkName: "ApiQpsMonitorList" */ '@views/MonitorList/ApiQpsMonitorList.vue'),
  },
  {
    path: '/coop_qps_flow_chart',
    name: 'CoopQpsFlowChart',
    component: () => import(/* webpackChunkName: "CoopQpsFlowChart" */ '@views/MonitorList/CoopQpsFlowChart.vue'),
  },
  {
    path: '/coop_api_qps_flow_chart',
    name: 'CoopApiQpsFlowChart',
    component: () => import(/* webpackChunkName: "CoopApiQpsFlowChart" */ '@views/MonitorList/CoopApiQpsFlowChart.vue'),
  },
  {
    path: '/coop_month_qps_flow_chart',
    name: 'CoopMonthQpsFlowChart',
    component: () =>
      import(/* webpackChunkName: "CoopMonthQpsFlowChart" */ '@views/MonitorList/CoopMonthQpsFlowChart.vue'),
  },
  {
    path: '/coop_qps_stat_list',
    name: 'CoopQpsStatList',
    component: () => import(/* webpackChunkName: "CoopQpsStatList" */ '@views/MonitorList/CoopQpsStatList.vue'),
  },
  {
    path: '/api_qps_stat_list',
    name: 'ApiQpsStatList',
    component: () => import(/* webpackChunkName: "CoopQpsStatList" */ '@views/MonitorList/ApiQpsStatList.vue'),
  },
  {
    path: '/coop_report_qps_stat_list',
    name: 'CoopReportQpsStatList',
    component: () => import(/* webpackChunkName: "CoopQpsStatList" */ '@views/MonitorList/CoopReportQpsStatList.vue'),
  },
  {
    path: '/audit_log_list',
    name: 'auditLogList',
    component: () => import(/* webpackChunkName: "CoopQpsStatList" */ '@views/auditLogList/auditLogList.vue'),
  },
  {
    path: '/park_traffic_flow',
    name: 'parkTrafficFlowList',
    component: () => import('@views/ParkTraffic/parkTrafficFlowList.vue'),
  },
  {
    path: '/api_module_config',
    name: 'ApiModuleConfig',
    component: () => import('@views/apiModuleConfig/ApiModuleConfig.vue'),
  },
]
